
import React, { useEffect, useState } from "react";

import ImageSlider from "./ImageSlider";
import one from "./images/4.png";
import two from "./images/2.png";
import three from "./images/3.png";
import four from "./images/5.png";
import five from "./images/6.png";
import six from "./images/7.png";
import seven from "./images/8.png";
import eight from "./images/9.png";
import nine from "./images/10.png";
import ten from "./images/1.png";
import comingsoon from "./images/comming.jpg";
import { Link } from "react-router-dom";
const Dashboard = () => {
  const [startSlider, setStartSlider] = useState(false);
  const images = [
    ten,
    two,
    three,
    four,
    five,
    one,
    six,
    seven,
    eight,
    nine,
    // Add more image URLs here
  ];
  useEffect(() => {
    const timer = setTimeout(() => setStartSlider(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
   
    <div style={{ minHeight: "100vh", backgroundColor: "#f3f4f6" }}>
      <header style={{ backgroundColor: "rgb(201 215 255)", padding: "1rem", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <h1 style={{ fontSize: "1.5rem", fontWeight: "600", color: "#1d4ed8" }}>Home</h1>
        <nav>
          <Link to="/contact" style={{ color: "#2563eb", textDecoration: "none", fontSize: "1.125rem" }}>
            Contact Us
          </Link>
        </nav>
      </header>
      <main style={{ padding: "1.5rem" }}>
        <ImageSlider images={images} />
      </main>
      </div>
  );
};

export default Dashboard;
